<template>
  <div class="pk">
    <div class="pk-head">
      <div class="pk-head__left">
        <el-input
          v-model="keyword"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          :placeholder="$t('subAccount.picker.searchApp')"
        />
      </div>
      <div class="pk-head__right">
        <span class="pk-head__count">{{ $t('subAccount.picker.selectedCount', { n: value.length }) }}</span>
        <span
          class="pk-head__clear"
          :class="{ 'is-disabled': !value.length }"
          @click="clearAll"
        >{{ $t('subAccount.picker.clearAll') }}</span>
      </div>
    </div>

    <div class="pk-body">
      <div class="pk-col" v-loading="loading">
        <div v-if="filtered.length" class="pk-row">
          <el-checkbox
            :value="allChecked"
            :indeterminate="allIndeterminate"
            @change="toggleAll"
          >{{ $t('subAccount.picker.selectAll') }}</el-checkbox>
        </div>

        <!-- 列表项只展示应用名 -->
        <div v-for="app in filtered" :key="app.id" class="pk-row">
          <el-checkbox
            :value="isChecked(app.id)"
            :title="app.name"
            @change="toggle(app.id)"
          >{{ app.name }}</el-checkbox>
        </div>

        <p v-if="!loading && !filtered.length" class="pk-empty">{{ $t('subAccount.picker.noMatch') }}</p>
      </div>

      <div class="pk-col pk-col--selected">
        <!-- 已选清单按候选列表的顺序排，不按勾选先后 -->
        <div v-for="app in selectedList" :key="app.id" class="pk-row">
          <span class="pk-row__label" :title="app.name">{{ app.name }}</span>
          <span class="pk-row__sub" :title="app.package_name">{{ app.package_name }}</span>
          <i class="el-icon-close pk-row__remove" @click="toggle(app.id)"></i>
        </div>
        <p v-if="!selectedList.length" class="pk-empty">{{ $t('subAccount.picker.noAppSelected') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPermissionPicker',
  props: {
    // 已选应用 id 数组
    value: {
      type: Array,
      default: () => []
    },
    // 候选应用，由弹窗统一拉取后传进来（两个弹窗共用一份，避免每次打开都请求）
    apps: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    // 应用名 / 包名任一命中即可（PRD 4.1.2 第 3.a 条）。
    // 字段缺失要兜成空串 —— String(undefined) 是 "undefined"，搜 "und" 会命中全部
    filtered() {
      const kw = this.keyword.trim().toLowerCase()
      if (!kw) return this.apps
      return this.apps.filter(
        a =>
          String(a.name || '').toLowerCase().indexOf(kw) !== -1 ||
          String(a.package_name || '').toLowerCase().indexOf(kw) !== -1
      )
    },
    checkedInFiltered() {
      return this.filtered.filter(a => this.isChecked(a.id)).length
    },
    // 「全选」只作用于当前搜索结果：搜出 3 个就只勾这 3 个，
    // 否则搜索过滤形同虚设
    allChecked() {
      return this.filtered.length > 0 && this.checkedInFiltered === this.filtered.length
    },
    allIndeterminate() {
      return this.checkedInFiltered > 0 && !this.allChecked
    },
    selectedList() {
      return this.apps.filter(a => this.isChecked(a.id))
    }
  },
  methods: {
    isChecked(id) {
      return this.value.indexOf(id) !== -1
    },
    emit(ids) {
      this.$emit('input', ids)
      this.$emit('change', ids)
    },
    toggle(id) {
      const ids = this.value.slice()
      const i = ids.indexOf(id)
      if (i === -1) ids.push(id)
      else ids.splice(i, 1)
      this.emit(ids)
    },
    toggleAll() {
      const on = !this.allChecked
      const ids = this.value.slice()
      this.filtered.forEach(a => {
        const i = ids.indexOf(a.id)
        if (on && i === -1) ids.push(a.id)
        if (!on && i !== -1) ids.splice(i, 1)
      })
      this.emit(ids)
    },
    clearAll() {
      if (!this.value.length) return
      this.emit([])
    }
  }
}
</script>

<style lang="scss" scoped>
@import './picker.scss';
</style>
